import { render, staticRenderFns } from "./ProjectReleaseModalForm.vue?vue&type=template&id=63ba28d9"
import script from "./ProjectReleaseModalForm.vue?vue&type=script&lang=js"
export * from "./ProjectReleaseModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports